import React from 'react';
import styled from 'styled-components';
import { PageTypes } from '../../../social/constants';
import MainLayout from '../../../social/layouts/Main';
import CommunitySideMenu from '../../../social/components/CommunitySideMenu';
import ExplorePage from '../../../social/pages/Explore';
import NewsFeedPage from '../../../social/pages/NewsFeed';
import CommunityFeedPage from '../../../social/pages/CommunityFeed';
import UserFeedPage from '../../../social/pages/UserFeed';
import CategoryCommunitiesPage from '../../../social/pages/CategoryCommunities';
import CommunityEditPage from '../../../social/pages/CommunityEdit';
import ProfileSettings from '../../../social/components/ProfileSettings';
import { useNavigation } from '../../../social/providers/NavigationProvider';
const ApplicationContainer = styled.div `
  height: 100%;
  width: 100%;
`;
const StyledCommunitySideMenu = styled(CommunitySideMenu) `
  min-height: 100%;
`;
const Community = () => {
    const { page } = useNavigation();
    return (React.createElement(ApplicationContainer, null,
        React.createElement(MainLayout, { aside: React.createElement(StyledCommunitySideMenu, { activeCommunity: page.communityId }) },
            page.type === PageTypes.Explore && React.createElement(ExplorePage, null),
            page.type === PageTypes.NewsFeed && React.createElement(NewsFeedPage, null),
            page.type === PageTypes.CommunityFeed && (React.createElement(CommunityFeedPage, { communityId: page.communityId, isNewCommunity: page.isNewCommunity })),
            page.type === PageTypes.CommunityEdit && (React.createElement(CommunityEditPage, { communityId: page.communityId, tab: page.tab })),
            page.type === PageTypes.Category && (React.createElement(CategoryCommunitiesPage, { categoryId: page.categoryId })),
            page.type === PageTypes.UserFeed && React.createElement(UserFeedPage, { userId: page.userId }),
            page.type === PageTypes.UserEdit && React.createElement(ProfileSettings, { userId: page.userId }))));
};
export default Community;
//# sourceMappingURL=index.js.map